const getDefaultState = () => {
  return {
    class_list_filter: {

    },
    is_open_get_filter: false, // 是否要获取 之所以可以在两个页面共用（班级列表、完结班级列表）因为是同一个班级详情

    from_where_list_to_detail: 'list', // finish-list  list

    finish_class_list_filter: {

    }
  }
}

const state = getDefaultState()

const mutations = {
  RESET_ALL_FILTER_DATA (state) {
    const {
      class_list_filter,
      is_open_get_filter
    } = getDefaultState()
    Object.assign(state, {
      class_list_filter,
      is_open_get_filter
    })
  },

  RESET_ALL_FINISH_FILTER_DATA (state) {
    const {
      finish_class_list_filter,
      is_open_get_filter
    } = getDefaultState()
    Object.assign(state, {
      finish_class_list_filter,
      is_open_get_filter
    })
  },
  SET_CLASS_LIST_FILTER (state, class_list_filter) {
    state.class_list_filter = class_list_filter
  },
  SET_FINISH_CLASS_LIST_FILTER (state, finish_class_list_filter) {
    state.finish_class_list_filter = finish_class_list_filter
  },

  SET_IS_OPEN_GET_FILTER (state, is_open_get_filter) {
    state.is_open_get_filter = is_open_get_filter
  },

  SET_FROM_WHERE_LIST_TO_DETAIL (state, from_where_list_to_detail) {
    state.from_where_list_to_detail = from_where_list_to_detail
  }
}

const actions = {
  // 更新班级列表的筛选条件
  updateClassListFilter ({ state, commit }, class_list_filter) {
    if (typeof class_list_filter === 'object' && !Array.isArray(class_list_filter)) {
      const origin_class_list_filter = state.class_list_filter

      const new_class_list_filter = Object.assign({}, origin_class_list_filter, class_list_filter)

      console.log(new_class_list_filter, 'new_class_list_filter')

      commit('SET_CLASS_LIST_FILTER', new_class_list_filter)
    }
  },

  // 更新完结班级列表的筛选条件
  updateFinishClassListFilter ({ state, commit }, finish_class_list_filter) {
    if (typeof finish_class_list_filter === 'object' && !Array.isArray(finish_class_list_filter)) {
      const origin_finish_class_list_filter = state.finish_class_list_filter

      const new_finish_class_list_filter = Object.assign({}, origin_finish_class_list_filter, finish_class_list_filter)

      console.log(new_finish_class_list_filter, 'new_finish_class_list_filter')

      commit('SET_FINISH_CLASS_LIST_FILTER', new_finish_class_list_filter)
    }
  },

  // 更新是否开启可以获取筛选条件
  changeIsOpenGetFilter ({ commit }, is_open_get_filter) {
    commit('SET_IS_OPEN_GET_FILTER', is_open_get_filter)
  },

  getClassListFilter ({ state, dispatch }) {
    const {
      is_open_get_filter,
      class_list_filter = {}
    } = state || {}

    console.log(is_open_get_filter, ' is_open_get_filter')
    console.log(class_list_filter, ' class_list_filter')

    const outer_filter = {
      ...(is_open_get_filter ? class_list_filter : {})
    }

    console.log(outer_filter, 'outer_filter')

    dispatch('changeIsOpenGetFilter', false)

    return outer_filter
  },

  getFinishClassListFilter ({ state, dispatch }) {
    const {
      is_open_get_filter,
      finish_class_list_filter = {}
    } = state || {}

    console.log(is_open_get_filter, ' is_open_get_filter')
    console.log(finish_class_list_filter, ' finish_class_list_filter')

    const outer_filter = {
      ...(is_open_get_filter ? finish_class_list_filter : {})
    }

    console.log(outer_filter, 'outer_filter')

    dispatch('changeIsOpenGetFilter', false)

    return outer_filter
  },

  // 更新从哪个列表进入的信息
  updateFromWhereListToDetail ({ commit }, from_where_list_to_detail) {
    commit('SET_FROM_WHERE_LIST_TO_DETAIL', from_where_list_to_detail)
  },

  // 清除所有缓存数据
  clearAll ({ commit }) {
    commit('RESET_ALL_FILTER_DATA')
  },

  clearFinishAll ({ commit }) {
    commit('RESET_ALL_FINISH_FILTER_DATA')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

